(function(){
  var title=document.querySelector('[data-cmp-title]');
  var name=document.querySelector('[data-cmp-chat-name]');
  var meta=document.querySelector('[data-cmp-chat-meta]');
  var avatar=document.querySelector('[data-cmp-avatar]');
  var body=document.querySelector('[data-cmp-body]');
  var alertEl=document.querySelector('[data-cmp-alert-text]');
  var chat=document.querySelector('[data-cmp-chat]');
  if(!title||!body) return;
  if(chat && chat.dataset.lpCmpBound) return;
  if(chat) chat.dataset.lpCmpBound = '1';

  var scenarios = [
    {
      title:'Ďalšia vec do police.',
      name:'Darček pre mamu · rodina',
      meta:'Mirka, Peter, ty',
      avatar:'D',
      day:'Pondelok',
      msgs:[
        {a:'Peter',t:'Čo dáme mame na narodeniny? 🎂',time:'20:14'},
        {a:'Mirka',t:'Neviem… možno parfum? Alebo kniha 🤷‍♀️',time:'20:31'},
        {a:'Peter',t:'Vlani to tiež nebolo super… 😕',time:'20:42'}
      ],
      typing:true,
      alert:'3 hodiny diskusie a stále bez nápadu'
    },
    {
      title:'„Čo mu kúpim?"',
      name:'Výročie · Lukáš & Ivana',
      meta:'Lukáš, ty',
      avatar:'L',
      day:'Štvrtok',
      msgs:[
        {a:'Ivana',t:'Zajtra je výročie a ja neviem čo 😭',time:'18:02'},
        {a:'Lukáš',t:'Parfum? Alebo poukaz do reštaurácie?',time:'18:15'},
        {a:'Ivana',t:'To má každý. Chcem niečo osobné.',time:'18:22'}
      ],
      typing:true,
      alert:'24 hodín a žiadny nápad na výročie'
    },
    {
      title:'Klasická e-shopová sranda.',
      name:'Svadobný dar · skupinka',
      meta:'Paťka, Janka, Filip, ty',
      avatar:'S',
      day:'Sobota',
      msgs:[
        {a:'Paťka',t:'Na svadbu Lukáša, poskladáme sa? 💍',time:'11:04'},
        {a:'Filip',t:'Zase kávovar ako naposledy?',time:'11:28'},
        {a:'Janka',t:'Radšej nie… ten sa len odkladá 🥲',time:'11:35'}
      ],
      typing:true,
      alert:'Tretí darček, čo skončí v kartóne'
    },
    {
      title:'Kolega ide do dôchodku.',
      name:'Firemný darček · HR',
      meta:'Anna, Juraj, ty',
      avatar:'K',
      day:'Utorok',
      msgs:[
        {a:'Anna',t:'30 rokov v robote, kúpime mu hrnček? ☕',time:'09:12'},
        {a:'Juraj',t:'Alebo pero? Plaketa?',time:'09:20'},
        {a:'Anna',t:'Toto si zaslúži viac ako plaketu 😤',time:'09:24'}
      ],
      typing:true,
      alert:'30 rokov práce · hrnček za 8 €'
    },
    {
      title:'Vianoce za dverami.',
      name:'Vianoce · rodina',
      meta:'Mama, Tato, ty',
      avatar:'V',
      day:'Nedeľa',
      msgs:[
        {a:'Mama',t:'Už si niečo zohnala babke? 🎄',time:'19:45'},
        {a:'Ty',t:'Ešte nie… všade dlhé čakania',time:'19:52'},
        {a:'Tato',t:'Každý rok to isté mučenie 😅',time:'20:01'}
      ],
      typing:true,
      alert:'10 dní do Vianoc a stále nič'
    },
    {
      title:'Narodeniny kamošky.',
      name:'Narodky · Lea 30',
      meta:'Tim, Kika, ty',
      avatar:'N',
      day:'Piatok',
      msgs:[
        {a:'Tim',t:'30-ka, ideme do kvetinárstva? 💐',time:'14:10'},
        {a:'Kika',t:'Kvety zvädnú za 4 dni…',time:'14:15'},
        {a:'Ty',t:'Chcem niečo, čo si zapamätá natrvalo',time:'14:22'}
      ],
      typing:true,
      alert:'Kvety zvädnú · spomienka by mala trvať'
    },
    {
      title:'Deň otcov nás zaskočil.',
      name:'Deň otcov · súrodenci',
      meta:'Jakub, Soňa, ty',
      avatar:'O',
      day:'Štvrtok',
      msgs:[
        {a:'Jakub',t:'Zabudli sme zase na otcov deň… 🤦',time:'21:02'},
        {a:'Soňa',t:'Minule ponožky, pred tým káva, pred tým kniha.',time:'21:08'},
        {a:'Ty',t:'Má 60 a stále všetko odkladá do skrine 😕',time:'21:12'}
      ],
      typing:true,
      alert:'5. ročník za sebou bez reakcie'
    },
    {
      title:'Valentín. Zase.',
      name:'Valentín 💘',
      meta:'Miška, ty',
      avatar:'V',
      day:'Pondelok',
      msgs:[
        {a:'Miška',t:'Nehovor že kúpiš zase parfum 🙄',time:'12:30'},
        {a:'Ty',t:'Alebo kytku a čokoládu…',time:'12:33'},
        {a:'Miška',t:'Po 7 rokoch chcem niečo, čo mi vyrazí dych 🥺',time:'12:41'}
      ],
      typing:true,
      alert:'Parfum #8 v rade, tento rok zlyhať nemôžeš'
    },
    {
      title:'Babka je nemožná.',
      name:'Darček pre svokru 👵',
      meta:'Manžel, ty',
      avatar:'B',
      day:'Sobota',
      msgs:[
        {a:'Ty',t:'Svokra má narodeniny a ja mám depku 😩',time:'10:15'},
        {a:'Manžel',t:'Vlani si dostala „aspoň neodhodím hneď" 😂',time:'10:22'},
        {a:'Ty',t:'Tento rok ju MUSÍM dostať. Doslova.',time:'10:28'}
      ],
      typing:true,
      alert:'Úsmev od svokry · dosiaľ nedosiahnutý level'
    },
    {
      title:'Prvé bábätko v rodine.',
      name:'Narodenie · rodina',
      meta:'Mama, Babka, ty',
      avatar:'M',
      day:'Streda',
      msgs:[
        {a:'Mama',t:'Čo dáme Lucke do pôrodnice?',time:'16:20'},
        {a:'Babka',t:'Osušky? Oblečenie? Detská postieľka?',time:'16:31'},
        {a:'Mama',t:'To má každý. Chcem niečo, čo zostane navždy 💛',time:'16:40'}
      ],
      typing:true,
      alert:'Bábätká rastú · spomienka musí zostať'
    },
    {
      title:'Tajný Ježiško v práci.',
      name:'Firemné Vianoce · účty',
      meta:'Janka, Ondro, ty',
      avatar:'T',
      day:'Pondelok',
      msgs:[
        {a:'Janka',t:'Dostala som šéfa 😱 limit 15 €',time:'13:04'},
        {a:'Ondro',t:'Hrnček s nápisom „Boss of the year" ? 🫠',time:'13:09'},
        {a:'Ty',t:'Alebo stres-ballik z Pepca… prosím nie zase 🙏',time:'13:14'}
      ],
      typing:true,
      alert:'Druhá strana: pohľad na hrnček = polovica úsmevu'
    },
    {
      title:'Kolaudácia u kamošov.',
      name:'Nový byt · Filip & Mia',
      meta:'Dávid, Nika, ty',
      avatar:'K',
      day:'Nedeľa',
      msgs:[
        {a:'Dávid',t:'Filip kolauduje byt, čo donesieme?',time:'18:45'},
        {a:'Nika',t:'Izbový kvet? Sviečka? Chlieb a soľ 🥖',time:'18:52'},
        {a:'Ty',t:'Chcem dar, čo tam zostane visieť 20 rokov',time:'19:01'}
      ],
      typing:true,
      alert:'Ďalšia izbovka · za mesiac uschne'
    }
  ];

  function render(s){
    title.textContent = s.title;
    name.textContent = s.name;
    meta.textContent = s.meta;
    avatar.textContent = s.avatar;
    alertEl.textContent = s.alert;
    var html = '<div class="lp-chat__day">'+s.day+'</div>';
    s.msgs.forEach(function(m){
      html += '<div class="lp-chat__msg lp-chat__msg--in"><span class="lp-chat__msg-author">'+m.a+'</span><div class="lp-chat__bubble">'+m.t+'</div><span class="lp-chat__time">'+m.time+'</span></div>';
    });
    if(s.typing) html += '<div class="lp-chat__typing" role="status" aria-label="Píše"><span></span><span></span><span></span></div>';
    body.innerHTML = html;
  }

  var i = Math.floor(Math.random()*scenarios.length);
  render(scenarios[i]);

  function next(){
    i = (i+1) % scenarios.length;
    chat.style.transition = 'opacity .45s ease, transform .45s ease';
    chat.style.opacity = '0';
    chat.style.transform = 'translateY(8px)';
    setTimeout(function(){
      render(scenarios[i]);
      chat.style.opacity = '1';
      chat.style.transform = 'translateY(0)';
    }, 480);
  }

  var _cmpTimer = null;
  function startCmp(){ if(_cmpTimer) return; _cmpTimer = setInterval(next, 9000); }
  function stopCmp(){ if(_cmpTimer){ clearInterval(_cmpTimer); _cmpTimer = null; } }
  startCmp();
  document.addEventListener('visibilitychange', function(){
    if(document.hidden) stopCmp(); else startCmp();
  });
})();